/* ══════════════════════════════════════════════════════════════════
   BUSCADOR
   ────────────────────────────────────────────────────────────────
   Tres cosas que estaban mal, cada una por su lado:

   1. LOS CAMPOS. Shopify busca por defecto dentro de la descripcion y las
      etiquetas. La ficha del Monterrey dice que juega en Mexico, asi que
      «Mexico» lo devolvia. Se acota a titulo y tipo de producto.

   2. EL RELLENO. El buscador sugerido intenta devolver siempre el cupo
      que le pidas y, cuando se le acaban las coincidencias buenas,
      rellena con parecidos flojos. Por eso «nix» devolvia Barcelona,
      Miami Heat, Orlando Magic y Toronto Raptors: ninguno tiene «nix» en
      el nombre, eran relleno.

      Aqui se filtra de verdad y — esto es lo que estaba mal — si despues
      de filtrar no queda NADA, se dice que no hay nada. La version
      anterior mostraba el relleno igual, «para no dejar la pantalla
      vacia». Eso era peor que vacio: le enseñaba al cliente cosas que no
      pidio y parecia un buscador roto.

   3. EL ORDEN. Venian revueltos. Ahora salen como se piensan: local,
      visita, la tercera o alternativa de esta temporada, niño, retro, y
      de ultimo lo que no es camiseta — jackets, conjuntos y kits.
   ═════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var panel = document.getElementById('busca');
  if (!panel) { return; }

  var campo  = panel.querySelector('[data-busca-campo]');
  var lista  = panel.querySelector('[data-busca-lista]');
  var pie    = panel.querySelector('[data-busca-pie]');
  var estado = panel.querySelector('[data-busca-estado]');
  var CAMPOS = 'title,product_type';

  var abierto = false, aborto = null, reloj = null, ultimo = '';

  function urlTodos(q) {
    return '/search?q=' + encodeURIComponent(q) +
           '&type=product&options%5Bprefix%5D=last&options%5Bfields%5D=' + CAMPOS;
  }

  function plano(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  /* El orden en que la gente piensa una camiseta. */
  function rango(p) {
    var t = plano(p.title);
    var tipo = plano(p.product_type || '');
    if (tipo.indexOf('jacket') !== -1 || tipo.indexOf('conjunto') !== -1 ||
        tipo.indexOf('entrenamiento') !== -1) { return 6; }
    if (tipo.indexOf('retro') !== -1) { return 5; }
    if (tipo.indexOf('nino') !== -1) { return t.indexOf('visita') !== -1 ? 4.5 : 4; }
    if (t.indexOf('visita') !== -1) { return 2; }
    if (t.indexOf('tercera') !== -1 || t.indexOf('cuarta') !== -1 ||
        t.indexOf('alternativa') !== -1) { return 3; }
    return 1;
  }

  function ordenar(ps) {
    return ps.map(function (p, i) { return { p: p, r: rango(p), i: i }; })
             .sort(function (a, b) { return a.r - b.r || a.i - b.i; })
             .map(function (x) { return x.p; });
  }

  /* Solo pasa lo que de verdad contiene lo que se escribio. Si no queda
     nada, devuelve vacio A PROPOSITO: ver arriba, punto 2. */
  function deVerdad(productos, q) {
    var trozos = plano(q).split(/\s+/).filter(Boolean);
    if (!trozos.length) { return []; }
    return productos.filter(function (p) {
      var texto = plano(p.title + ' ' + (p.product_type || ''));
      return trozos.every(function (t) { return texto.indexOf(t) !== -1; });
    });
  }

  function plata(v) {
    var n = Math.round(parseFloat(v || '0'));
    if (!isFinite(n) || n <= 0) { return ''; }
    return '₡ ' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function foto(p) {
    var u = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
    if (!u) { return ''; }
    return u.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
  }

  function escapar(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
  }

  function abrir() {
    if (abierto) { return; }
    panel.hidden = false;
    void panel.offsetWidth;
    panel.classList.add('is-on');
    document.documentElement.classList.add('busca-abierta');
    abierto = true;
    setTimeout(function () { campo.focus(); campo.select(); }, 60);
  }

  function cerrar() {
    if (!abierto) { return; }
    panel.classList.remove('is-on');
    document.documentElement.classList.remove('busca-abierta');
    abierto = false;
    setTimeout(function () { if (!abierto) { panel.hidden = true; } }, 220);
  }

  function vaciar(msg) {
    lista.innerHTML = '';
    pie.hidden = true;
    estado.innerHTML = msg || '';
    estado.hidden = !msg;
  }

  function pintar(productos, q) {
    if (!productos.length) {
      vaciar('No encontramos nada con «' + escapar(q) + '».<br>' +
             'Escribinos por WhatsApp con el equipo y la temporada: si existe, la conseguimos.');
      return;
    }
    estado.hidden = true;
    lista.innerHTML = productos.map(function (p) {
      var f = foto(p);
      return '<a class="busca-fila" href="' + p.url + '">' +
               '<span class="busca-ph">' +
                 (f ? '<img src="' + f + '" alt="" loading="lazy" decoding="async" width="80" height="80">' : '') +
               '</span>' +
               '<span class="busca-txt">' +
                 '<b>' + escapar(p.title) + '</b>' +
                 '<span>' + escapar(p.product_type || '') + '</span>' +
               '</span>' +
               '<span class="busca-precio">' + plata(p.price) + '</span>' +
             '</a>';
    }).join('');
    pie.hidden = false;
    pie.setAttribute('href', urlTodos(q));
    pie.querySelector('b').textContent = q;
  }

  function buscar(q) {
    if (aborto) { aborto.abort(); }
    aborto = new AbortController();

    /* Se piden 10 (el tope de Shopify) porque despues se filtra: si se
       pidieran 6, el filtro podria dejar 2. */
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources%5Btype%5D=product' +
              '&resources%5Blimit%5D=10' +
              '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
              '&resources%5Boptions%5D%5Bfields%5D=' + CAMPOS;

    fetch(url, { signal: aborto.signal })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (q !== ultimo) { return; }
        var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
        pintar(ordenar(deVerdad(ps, q)), q);
      })
      .catch(function (e) {
        if (e.name === 'AbortError') { return; }
        vaciar('No se pudo buscar ahora mismo.');
        pie.hidden = false;
        pie.setAttribute('href', urlTodos(q));
      });
  }

  campo.addEventListener('input', function () {
    var q = campo.value.trim();
    ultimo = q;
    clearTimeout(reloj);
    if (q.length < 2) { vaciar(''); return; }
    reloj = setTimeout(function () { buscar(q); }, 180);
  });

  campo.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      var q = campo.value.trim();
      if (q) { location.href = urlTodos(q); }
    }
    if (e.key === 'ArrowDown') {
      var primera = lista.querySelector('.busca-fila');
      if (primera) { e.preventDefault(); primera.focus(); }
    }
  });

  lista.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') { return; }
    var filas = Array.prototype.slice.call(lista.querySelectorAll('.busca-fila'));
    var i = filas.indexOf(document.activeElement);
    if (i === -1) { return; }
    e.preventDefault();
    if (e.key === 'ArrowDown' && filas[i + 1]) { filas[i + 1].focus(); }
    else if (e.key === 'ArrowUp') { if (filas[i - 1]) { filas[i - 1].focus(); } else { campo.focus(); } }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-busca-abrir]')) { e.preventDefault(); abrir(); return; }
    if (!abierto) { return; }
    if (e.target.closest('[data-busca-x]')) { e.preventDefault(); cerrar(); return; }
    if (e.target === panel) { cerrar(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && abierto) { cerrar(); }
  });

  Array.prototype.forEach.call(document.querySelectorAll('form[action*="/search"]'), function (f) {
    f.addEventListener('submit', function (e) {
      var input = f.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) { return; }
      e.preventDefault();
      location.href = urlTodos(input.value.trim());
    });
  });
})();
